import { objectSchemaOf, Joi } from '../helpers';
import type { IEntityType } from './entityType';
import { entityTypeSchema } from './entityType';

export interface IEntitiesRequestParams {
  organisationId: string;
}

export const entitiesRequestParamsSchema = objectSchemaOf<IEntitiesRequestParams>(
  {
    organisationId: Joi.string().required(),
  }
).required();

export type EntitiesResponse = IEntityType[];

export const entitiesResponseSchema = Joi.array()
  .items(entityTypeSchema)
  .required();
